module.exports = __webpack_public_path__ + "static/media/Bike_966x644.069527e2.jpg";